import { IPrecatorio } from "src/services/interfaces/IPrecatorio";
import * as React from "react";
import { Row, Col } from "antd";
import { MoneyMask } from "src/util/Masks/MoneyMask";
import StandardButton from "src/components/common/StandardButton/StandardButton";
import Title from "src/components/common/Title";
import { PbrSeparator } from "src/components/common/Separator/Separator";
import { useContext } from "react";
import { AuthContext } from "src/components/context/AuthContext";
import { PercentageMask } from "src/util/Masks/PercentageMask";
import { IQuote } from "src/services/interfaces/trade/precificacao/IQuote";

export function MonitorPrecatoriosQuote(props: { precatorio: IPrecatorio; quote: IQuote; onReject: () => void; onAccept: () => void }) {
  const { currentUser } = useContext(AuthContext);

  const precatorio = props.precatorio;
  const quote = props.quote;

  return (
    <>
      <Row>
        <Col xs={24} sm={24} md={12} lg={12}>
          <h5 style={{ font: "16px 'Open Sans'", color: "#888888" }}>Processo:</h5>
          <Title size="h2" preset="bolder">
            {precatorio.processCode}
          </Title>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <h5 style={{ font: "16px 'Open Sans'", color: "#888888" }}>Valor expedido:</h5>
          <Title size="h2" preset="bolder">
            {MoneyMask(precatorio.principal)}
          </Title>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={12} lg={12}>
          <h5 style={{ font: "16px 'Open Sans'", color: "#888888" }}>Valor atual:</h5>
          <Title size="h2" preset="bolder">
            {MoneyMask(precatorio.principal + precatorio.interest)}
          </Title>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <h5 style={{ font: "16px 'Open Sans'", color: "#888888" }}>Valor venda:</h5>
          <Title size="h2" preset="bolder">
            {MoneyMask(quote.pricing.price)}
          </Title>
        </Col>
      </Row>
      {currentUser.permissions.userCanSeeCommission && (
        <Row>
          <Col xs={24} sm={24} md={12} lg={12}>
            <h5 style={{ font: "16px 'Open Sans'", color: "#888888" }}>Comissão:</h5>
            <Title size="h2" preset="bolder">
              {`${PercentageMask(quote.pricing?.commission?.officer?.userCommissionCalculated?.percentage ?? quote.pricing?.commission?.officer?.full?.percentage, 2, 2)} `}
            </Title>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <h5 style={{ font: "16px 'Open Sans'", color: "#888888" }}>Valor Comissão:</h5>
            <Title size="h2" preset="bolder">
              {MoneyMask(quote.pricing?.commission?.officer?.userCommissionCalculated?.value ?? quote.pricing?.commission?.officer?.full?.value)}
            </Title>
          </Col>
        </Row>
      )}
      <PbrSeparator />
      <Row gutter={16} className="actions-btn-row">
        <Col xs={24} sm={24} md={12} lg={12}>
          <StandardButton preset="outline" onClick={props.onReject}>
            Voltar
          </StandardButton>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <StandardButton onClick={() => props.onAccept()}>Prosseguir venda</StandardButton>
        </Col>
      </Row>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/pages/gerencial/precatorios/MonitorPrecatoriosQuote.tsx